import type { ErrorEvent, EventHint } from "@sentry/react";
import { IGNORED_ERROR_MESSAGES } from "@common/config/sentryIgnoredErrors";

/**
 * Frontend beforeSend hook for filtering out expected errors from Sentry
 * Used in sentryManager.ts
 */
export function sentryBeforeSend(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
    // Expected auth-redirect noise: the axios interceptor already redirects the
    // user to /login on a 401 for /a/ and /b/ routes, then throws
    // NotAuthenticatedError to short-circuit the promise chain. That throw
    // surfaces as unhandled rejections (dashboard cards fire without .catch),
    // producing a burst of events per load. Drop by exception name — the
    // message is dynamic (url/expiration) so it can't be matched below.
    // UnexpectedAuthenticateError is intentionally NOT dropped; it flags a
    // genuine FE/BE expiration disagreement worth investigating.
    const original = hint.originalException;
    if (original instanceof Error && original.name === 'NotAuthenticatedError') {
        return null;
    }

    const message = event.message || '';

    // Check if this message should be ignored
    for (const ignoredPattern of IGNORED_ERROR_MESSAGES) {
        if (message === ignoredPattern) {
            console.log('Sentry (FE): Ignoring expected error:', message);
            return null;
        }
    }

    return event; // Send everything else to Sentry
}
